import { useEasyModeContext } from '../../contexts/EasyModeContext';
import useEasyModeDropzone from '../../hooks/useEasyModeDropzone';
import EasyModeDropzone from './EasyModeDropzone';
import EasyModePartnerImport from './EasyModePartnerImport';
import EasyModeUploadList from './EasyModeUploadList';
import { stepBodyClasses } from './easyModeClasses';

const EasyModeDocumentStep = () => {
  const { caseId, documents, partnerImport } = useEasyModeContext();
  const dropzone = useEasyModeDropzone({
    existingFileKeys: documents.existingFileKeys,
    onFilesAccepted: documents.addFiles
  });

  return (
    <div className={stepBodyClasses}>
      <EasyModePartnerImport
        caseId={caseId}
        partners={partnerImport.availablePartners}
        isExpanded={partnerImport.isExpanded}
        selectedPartner={partnerImport.selectedPartner}
        selectedCase={partnerImport.selectedCase}
        isAutoImporting={partnerImport.isAutoImporting}
        importedPartnerLabel={partnerImport.importedPartnerLabel}
        partnerLabel={partnerImport.partnerLabel}
        partnerCases={partnerImport.partnerCases}
        onToggleExpanded={partnerImport.toggleExpanded}
        onSelectPartner={partnerImport.selectPartner}
        onClearPartner={partnerImport.clearPartner}
        onSelectCase={partnerImport.selectCase}
        onCloseConfirmation={partnerImport.closeConfirmation}
        onImported={partnerImport.handleImported}
        onDismissBanner={partnerImport.dismissBanner}
      />

      <EasyModeDropzone
        isDragActive={dropzone.isDragActive}
        rejections={dropzone.rejections}
        fileInputRef={dropzone.fileInputRef}
        folderInputRef={dropzone.folderInputRef}
        dragHandlers={dropzone.dragHandlers}
        cloudSources={dropzone.cloudSources}
        onBrowseFiles={dropzone.openFilePicker}
        onBrowseFolder={dropzone.openFolderPicker}
        onFilesSelected={dropzone.handleFilesSelected}
      />

      {documents.totalCount > 0 && (
        <EasyModeUploadList
          rows={documents.rows}
          headerLabel={documents.headerLabel}
          completedCount={documents.completedCount}
          totalCount={documents.totalCount}
          onRetry={documents.retryRow}
          onRemove={documents.removeRow}
        />
      )}
    </div>
  );
};

export default EasyModeDocumentStep;
